/**
 * @description 邀请奖励
 */

import { RewardTypeEnum, RewardStatusEnum } from "@/types/reward";
import Image from "next/image";
import { RewardIcon } from "./reward-icon";
import { isEmpty } from "lodash-es";
import ProgressBar from "@/features/reward/components/progress-bar";
import GiftIcon from '@/features/reward/assets/gift.png';
import { Button } from "@/components/ui/button";
import { useBalanceFormatter } from "@/hooks/use-balance-formatter";
import { useTranslations } from "next-intl";
import { useClaimDebounce } from "./use-claim-debounce";

interface ReferralRewardProps {
  status: RewardStatusEnum;
  wageredProgress?: {
    currentAmount: number;
    targetAmount: number;
  };
  depositProgress?: {
    currentAmount: number;
    targetAmount: number;
  };
  amount: number;
  currency: string;
  claimCurrency: string;
  claimAmount: number;
  bonusWagerMultiple?: number;
  calendarAmount?: number;
  onClaim: () => Promise<unknown>;
}

export const ReferralReward = (props: ReferralRewardProps) => {
  const { status, wageredProgress, depositProgress, amount, currency, onClaim } = props;
  const { formatCurrencyDetail } = useBalanceFormatter();
  const ableClaim = status === RewardStatusEnum.CLAIM;
  const showProgress = status === RewardStatusEnum.PROGRESS;
  const progressPercent = showProgress && !isEmpty(wageredProgress) && !isEmpty(depositProgress) ?
    (+wageredProgress.currentAmount / (+wageredProgress.targetAmount) + (+depositProgress.currentAmount) / (+depositProgress.targetAmount)) / 2 * 100 : 0;
  const t = useTranslations('reward');
  const { loading, run } = useClaimDebounce(onClaim);

  const handleClaim = async () => {
    return run();
  };

  return (
    <div className="bg-dark-special rounded-lg py-3 pr-3 flex items-center justify-between" style={{ background: 'linear-gradient(to bottom right, #1D3657 0%, #1B2131 65%, #1B2131 100%)', }}>
      <RewardIcon type={RewardTypeEnum.INVITE_REWARD} className="mr-2.5" />
      <div className="flex-1">
        <div className="flex items-center">
          <div className="text-white text-xs font-medium leading-3">{t('refferralBonus')}</div>
        </div>
        {
          showProgress && (
            <>
              <div className="flex items-center justify-between mt-3">
                <div className="text-tertiary text-[11px] font-medium leading-3">
                  {t('recharge')} {`${formatCurrencyDetail((depositProgress?.currentAmount || 0))} / ${formatCurrencyDetail((depositProgress?.targetAmount || 0)) + ' ' + currency}`},
                  {t('wager')} {`${formatCurrencyDetail((wageredProgress?.currentAmount || 0))} / ${formatCurrencyDetail((wageredProgress?.targetAmount || 0)) + ' ' + currency}`}
                </div>
                <Image src={GiftIcon.src} alt="gift" width={12} height={12} />
              </div>
              <ProgressBar progress={progressPercent} className="mt-2 h-2" barClassName="bg-accent-blue" />
            </>
          )
        }
        {
          ableClaim && (
            <div className="text-[#FFC600] text-xss font-medium leading-3 mt-3">
              {formatCurrencyDetail(amount)} {currency}
            </div>
          )
        }
      </div>
      {ableClaim && (
        <Button
          variant="success"
          className="w-[90px] h-8 ml-[10px]"
          onClick={handleClaim}
          disabled={loading}
          loading={loading}
        >{t('claim')}</Button>
      )}
    </div>
  );
};
